import * as React from "react";
import {useHistory} from "react-router-dom";

import Button from "@khanacademy/wonder-blocks-button";
import {doNotTranslateYet} from "@khan/i18n";
import {PermissionsInfo} from "@khan/shared-core";
import {getLoginUrl} from "@khan/urls";

import CreatePythonUserProgramModal from "../create-python-user-program-modal.tsx";
import {useCreatePythonProgram} from "../use-create-python-program.ts";

type Props = {
    curationNodeSlug: string;
    icon?: React.ComponentProps<typeof Button>["startIcon"];
};

export default function NewProgramButton({
    curationNodeSlug,
    icon,
}: Props): React.ReactElement {
    const [isModalOpen, setIsModalOpen] = React.useState(false);

    const history = useHistory();

    const {createPythonProgram, result} = useCreatePythonProgram();
    const isSaving = result?.status === "loading";
    const onSave = async (programName: string): Promise<boolean> => {
        const result = await createPythonProgram({
            curationNodeSlug,
            title: programName,
        });

        if (result.status === "success") {
            history.push(result.data.url);
            return true;
        }

        return false;
    };

    const onClick = () => {
        if (PermissionsInfo.isLoggedIn) {
            setIsModalOpen(true);
        } else {
            history.push(getLoginUrl(history.location.pathname));
        }
    };

    return (
        <>
            <Button startIcon={icon} kind="secondary" onClick={onClick}>
                {doNotTranslateYet`New program`}
            </Button>
            {isModalOpen && (
                <CreatePythonUserProgramModal
                    onClose={isSaving ? () => {} : () => setIsModalOpen(false)}
                    onSave={onSave}
                    isSaving={isSaving}
                />
            )}
        </>
    );
}
